export default "__VITE_ASSET__CWERJjsL__"